import gql from "graphql-tag";

export const UNPIN_POST = gql`
    mutation UnpinPost($postId: ID!) {
        unpinPost(input: {
            postId: $postId,
        }){
            user{
                username
            }
        }
    }
`;
